module.exports = __webpack_public_path__ + "static/media/arrington.db2cb44a.svg";